import { getOrElse } from 'fp-ts/Option';
import {
  StyledAffinityUsersWrapper,
  StyledCaptionSecondary,
  StyledHeading,
  StyledOverline,
  StyledSecondaryBodyText,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { ContainerStackedRow } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';
import { MultipleUsers24 } from 'ui/icons';
import { AFFINITY_USERS } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { localizeNumber } from 'utils/l10n/number';
import {
  useBrandAffinityTranslation,
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
} from 'modules/domains/brandAffinity';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import {
  defaultCalculatedUsersMetrics,
  useDataManagementContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import { localizePercent } from 'utils/l10n';
import {
  formatCountWithSign,
  formatPercentWithSign,
} from 'modules/intelligentInsights/domain.utils';
import {
  AffinityTopFlex,
  BoldCaption,
  StyledAffinityCounts,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/CohortAffinityUsers.styles';

export const CohortAffinityUsers = () => {
  const { t } = useBrandAffinityTranslation();
  const { selectedAffinityTab } = useCoreContext();
  const {
    managedInsightsData,
    timeSpan: { selectedTimespan },
  } = useDataManagementContext();
  const usersMetrics = getOrElse(() => defaultCalculatedUsersMetrics)(
    managedInsightsData.usersMetrics,
  );
  const { delta, history } = usersMetrics[selectedAffinityTab];

  return (
    <StyledAffinityUsersWrapper>
      <ContainerStackedRow>
        <StyledOverline>
          {`${t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[selectedAffinityTab])} ${AFFINITY_USERS}`}
        </StyledOverline>
        <AffinityTopFlex>
          <MultipleUsers24 />
          <StyledHeading>{localizeNumber(history.count || 0)}</StyledHeading>
          <StyledSecondaryBodyText>
            {`(${localizePercent(history.percent || 0)})`}
          </StyledSecondaryBodyText>
        </AffinityTopFlex>
        <StyledAffinityCounts>
          <BoldCaption>{formatCountWithSign(delta.count)}</BoldCaption>
          <StyledCaptionSecondary>
            ({formatPercentWithSign(delta.percent)} percentage points) from {selectedTimespan} days
            ago
          </StyledCaptionSecondary>
        </StyledAffinityCounts>
      </ContainerStackedRow>
    </StyledAffinityUsersWrapper>
  );
};
